module.exports = __webpack_public_path__ + "static/media/logo_border_star_00010.f1d098ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/border-star/logo_border_star_00010.png
// module id = 423
// module chunks = 0